export default {
    USERS: "users",
    CONNECTIONS: "connections",
    ROLES: "roles",
    ACTION_LOG: "actionLog",
    TASK_STATISTICS: "taskStatistics",
    METHODS: "methods",
    PASSWORD_POLICY: "passwordPolicy",
    BILLING: "billing"
};
